import React from 'react';
import Teams from '../../api/team'
import { Link } from "react-router-dom";
import 'swiper/css';
import 'swiper/css/pagination';
import sImg3 from '../../images/icons/icon_linkedin.svg'


const TeamSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (

        <section className="team_section xb-hidden section_space">
            <div className="container">
                <div className="heading_block text-center">
                    <h2 className="heading_text mb-0 text-start">
                        De mensen achter het bedrijf
                    </h2>
                </div>

                <div className="row">
                    {Teams.slice(0, 6).map((team, tm) => (
                        <div className="col-lg-4 col-md-6 col-sm-6" key={tm}>
                            <div className="team_block">
                                <div className="team_member_image">
                                    <Link onClick={ClickHandler} className="image_wrap" aria-label="Team Details Button" to={`/team/${team.slug}`}>
                                        <img src={team.tImg} alt="" />
                                        <i className="fa-solid fa-arrow-up-right"></i>
                                    </Link>
                                </div>
                                <div className="team_member_info">
                                    <h3 className="team_member_name">
                                        <Link onClick={ClickHandler} to={`/team/${team.slug}`}>{team.name}</Link>
                                    </h3>
                                    <h4 className="team_member_designation">{team.title}</h4>
                                    <ul className="social_icons_block unordered_list justify-content-center">
                                        <li>
                                            <Link onClick={ClickHandler} to={`/team/${team.slug}`}>
                                                <img src={sImg3} alt="Icon Linkedin" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to={`/team/${team.slug}`}>
                                                <i className="fa-solid fa-phone-volume"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="container">
                    <div className="btns_group pb-0">

                        <Link onClick={ClickHandler} className="btn btn-outline-light" to="/team">
                            <span className="btn_label" data-text="Lees meer over ons team!">Lees meer over ons team</span>
                            <span className="btn_icon">
                                <i className="fa-solid fa-arrow-up-right"></i>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TeamSection;